export const TWINKLE_SOCKET_AUTH_READY_EVENT = 'twinkle:socket-auth-ready';
export const TWINKLE_CLIENT_REFRESH_REQUIRED_EVENT =
  'twinkle:client-refresh-required';
export const TWINKLE_SERVER_HANDOFF_EVENT = 'twinkle_server_handoff';
